import { ListDataPage } from "./UpdateData";
import { SetStatusGlobal } from "../interface/Global";

export async function OpenPage(type: string, value?: string | number, valueSub?: string | number) {
    SetStatusGlobal('page', type);
    localStorage.setItem('page', type);
    
    ListDataPage();

    if(value !== undefined){
        SetStatusGlobal('page_id', value as number);
        localStorage.setItem('page_id', value.toString());
    }
    if (valueSub !== undefined) {
        SetStatusGlobal('page_sub', valueSub as string);
        localStorage.setItem('page_sub', valueSub.toString());
    }
}